// WHY R355: a fixed overscan gate around a small/right-hand cube still left
// 440px uncovered on a measured 2560px desktop. Changing object-fit or the final
// cube scale breaks the media/live match. Cover the viewport during scattered
// flight, then return to the exact original gate once every fragment is inside.
// Frames26+ are clear of every film edge; the final camera/pose stays unchanged.
export function installIntroCoverage(video,{readAnchor,signal}={}) {
 const layer=video.parentElement;
 let time=0,frame=null,raf=null,stopped=false,last=null;
 const hold=26/24,settle=34/24;
 const update=()=>{
  if(stopped)return;
  const a=readAnchor();if(!a||!(a.size>0))return;
  const halfX=a.size*32/15,halfY=a.size*1.8;
  const needed=Math.max(1,(Math.max(a.x,a.width-a.x)+1)/halfX,(Math.max(a.y,a.height-a.y)+1)/halfY);
  const t=Math.max(0,Math.min(1,(time-hold)/(settle-hold))),ease=t*t*(3-2*t);
  const scale=1+(needed-1)*(1-ease),value=scale===1?'none':`scale(${scale.toFixed(7)})`;
  if(layer.style.transformOrigin!=='50% 50%')layer.style.transformOrigin='50% 50%';
  if(layer.style.transform!==value)layer.style.transform=value;
  last={time,scale,needed,anchor:{...a},film:{left:a.x-halfX*scale,right:a.x+halfX*scale,top:a.y-halfY*scale,bottom:a.y+halfY*scale}};
 };
 const tick=(_now,meta)=>{
  frame=null;raf=null;if(stopped)return;
  time=meta?.mediaTime??video.currentTime;update();
  if(!video.paused&&!video.ended){
   if(video.requestVideoFrameCallback)frame=video.requestVideoFrameCallback(tick);
   else raf=requestAnimationFrame(tick);
  }
 };
 const sample=()=>{time=video.currentTime;update();};
 const start=()=>{sample();if(frame===null&&raf===null)tick();};
 // The placement owner may reset transform when it remeasures. Reapply the
// last decoded video time; never advance time inside the mutation callback.
 const observer=new MutationObserver(update);observer.observe(layer,{attributes:true,attributeFilter:['style']});
 const abort=new AbortController();
 for(const event of ['loadedmetadata','seeked','timeupdate','pause'])video.addEventListener(event,sample,{signal:abort.signal});
 video.addEventListener('playing',start,{signal:abort.signal});
 addEventListener('resize',update,{signal:abort.signal});
 const dispose=()=>{if(stopped)return;stopped=true;abort.abort();observer.disconnect();
  if(frame!==null)video.cancelVideoFrameCallback?.(frame);if(raf!==null)cancelAnimationFrame(raf);
  layer.style.transform='none';};
 video.addEventListener('ended',()=>{sample();dispose();},{signal:abort.signal});
 video.addEventListener('error',dispose,{signal:abort.signal});
 signal?.addEventListener('abort',dispose,{once:true});
 update();return {state:()=>last,dispose};
}
